// extracted by mini-css-extract-plugin
export default {"body":"popupDel_body__YgPnz","flex_button":"popupDel_flex_button__DgyJa"};